module.exports = __webpack_public_path__ + "img/2_2_redeem_type_1.05af3059.gif";